import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {PERMISSION_ALIASES} from 'core/constants/permissionAliases';
import {ROUTE} from 'core/routes';

import {NavigationContainer} from './styled';

export const AuditNavigation = () => {
    const {t} = useTranslation();
    return (
        <NavigationContainer>
            <NavBar>
                <PermissionAccess permissions={[PERMISSION_ALIASES.recallAuditLogView]}>
                    <NavLink exact to={ROUTE.RECALL_AUDIT}>
                        {t('pages.productCardAudit.tabs.recall')}
                    </NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.productCardAuditLogView]}>
                    <NavLink to={ROUTE.PRODUCT_CARD_AUDIT}>
                        {t('pages.productCardAudit.tabs.productCards')}
                    </NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.remarkingAuditLogView]}>
                    <NavLink to={ROUTE.REMARKING_AUDIT}>{t('pages.remarkingAudit.tab')}</NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.blockingAuditLogView]}>
                    <NavLink to={ROUTE.BLOCKING_AUDIT}>{t('pages.blockingAudit.tab')}</NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.withdrawalAuditLogView]}>
                    <NavLink to={ROUTE.WITHDRAWAL_AUDIT}>{t('pages.withdrawalAudit.tab')}</NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.returnAuditLogView]}>
                    <NavLink to={ROUTE.RETURN_AUDIT}>{t('pages.returnAudit.tab')}</NavLink>
                </PermissionAccess>
                <PermissionAccess permissions={[PERMISSION_ALIASES.customsAuditLogView]}>
                    <NavLink to={ROUTE.CUSTOMS_AUDIT}>{t('pages.customsAudit.tab')}</NavLink>
                </PermissionAccess>
            </NavBar>
        </NavigationContainer>
    );
};
